import { MotifIcon, MotifInput } from "@ey-xd/motif-react";
import { useState } from "react";
import {
  MotifActionIcVisibilityOff24px,
  MotifActionIcVisibility24px,
//   IconoirXmark
} from "@ey-xd/motif-icon";
import "./CustomMaskedInput.scss";
export default function CustomMaskedInput({
  disabled,
  value,
  onChange,
  maxLength,
  fieldFocus
}: any) {
  const [inputType, setInputType] = useState(true);
  return (
    <div className="unmaskedFiledscon">
      <MotifInput
        disabled={disabled}
        value={value}
        className={`${fieldFocus ? "motif-input-invalid" :""} unmaskedFiledsinput`}
        onChange={(e) =>{
            if(e.target.value===""){
                setInputType(true)
            }
            onChange(e.target.value)}}
        maxLength={maxLength}
        type={inputType ? "password" : "text"}
        hideClearButton={false}
      ></MotifInput>
      <div
        className="unmaskedFiledsEye"
      >
        {/* { value!=="" && value!==undefined && value!==null && <span onClick={() => onChange("")}>
        
          <MotifIcon
          size="24"
          strokeWidth="1.5"
        // stroke="50px"
          src={
            IconoirXmark
          }
        ></MotifIcon>
        </span>} */}
        {value!=="" && value!==undefined && value!==null &&<span onClick={() => setInputType(!inputType)}>
        <MotifIcon
          size="24"
          strokeWidth="1"
          src={
            inputType
              ? MotifActionIcVisibilityOff24px
              : MotifActionIcVisibility24px
          }
        ></MotifIcon>
        </span>}
      </div>
    </div>
  );
}
